import React, { ReactNode } from 'react'
import styles from '~/styles/molecules/row/row.module.scss'

import { ChildProps } from '~/common/define/props'
import { addClass } from '~/common/utils/html'

export enum RowColumnLayoutFrame {
  SMALL,
  MEDIUM,
}

interface Props extends ChildProps {
  subNode?: ReactNode
  frame?: RowColumnLayoutFrame
  current?: boolean
  vertical?: boolean
}

const RowColumnLayout = ({children, subNode = null, frame = null, current = false, vertical = false}: Props) => {
  return (
    <div className={styles.columnLayout
      + addClass(frame == RowColumnLayoutFrame.SMALL ? styles.small :
        frame == RowColumnLayoutFrame.MEDIUM ? styles.medium : '')
      + addClass(styles.columnLayout__current, current)
      + addClass(styles.columnLayout__vertical, vertical)}>
      {children}
      {subNode &&
        <div className={styles.columnLayout__sub}>
          {subNode}
        </div>
      }
    </div>
  )
}

export default RowColumnLayout
